import { Typography, CircularProgress } from "@mui/material";
import { tss } from "tss-react";
import commonStyles from "styles/common";

const useStyles = tss.create(() => ({
    root: {
        width: "100%",
        maxWidth: "max-content",
        backgroundColor: "#a0a0a0de",
        borderRadius: 4,
        padding: 12,
        opacity: 0.8,
    },
    paper: {
        width: "80%",
        maxHeight: 435,
    },
    title: {
        padding: "3px 24px",
    },
    content: {
        padding: "40px 24px",
        width: 360,
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
}));

export default function PendingDialog({ message = "" }) {
    const { classes } = useStyles();
    const { classes: common } = commonStyles();
    return (
        <div
            style={{
                position: "fixed",
                zIndex: 1300,
                inset: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
        >
            <div
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <div className={classes.root}>
                    <div style={{ display: "inline-flex", alignItems: "center", flexDirection: "column" }}>
                        <div className={common.middleCenter} style={{ width: "100%", height: 40, marginTop: 10 }}>
                            <CircularProgress />
                        </div>
                        <div className={common.middleCenter} style={{ width: "100%", height: 40 }}>
                            <Typography
                                style={{
                                    width: "max-content",
                                    minWidth: 100,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    textAlign: "center",
                                }}
                                noWrap
                            >
                                {message}
                            </Typography>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
